/*!
 * KoliBri - The accessible HTML-Standard
 */
import { h } from './index-C_ZKddLG.js';
import { b as bem } from './bem-registry-3ondDImf.js';

const clickButtonBem = bem.forBlock('kol-click-button');
const BEM_CLASS_CLICK_BUTTON = clickButtonBem();
const BEM_CLASS_CLICK_BUTTON__LABEL = clickButtonBem('label');
const ClickButtonFC = ({ label, handleClick, refButton }) => (h("button", { class: BEM_CLASS_CLICK_BUTTON, ref: refButton, onClick: handleClick, onKeyDown: (event) => event.preventDefault() }, h("span", { class: BEM_CLASS_CLICK_BUTTON__LABEL }, label)));

export { ClickButtonFC as C };
//# sourceMappingURL=component-WjvIfI-H.js.map

//# sourceMappingURL=component-WjvIfI-H.js.map